// src/pages/Home.jsx
import React from 'react';
import Hero from '../components/AfscHero';
import Intro from '../components/AfscIntro';
import Stats from '../components/AfscCEO';
import Footer from '../components/Footer';

function AkijFoundation() {
  return (
    <>
      <Intro />
      <Hero />
      <Stats />
      <Footer />
    </>
  );
}

export default AkijFoundation;
